export const Common = {
  titleProject: 'Moviment@',
  subTitleProject: 'Fornecedores',
  labelEmail: 'E-mail',
  labelPassword: 'Palavra-Passe',
  login: 'Iniciar Sessão',
  logout: 'Sair',
  send: 'Enviar',
  back: 'Voltar',
  register: 'Registar',
  cancel: 'Cancelar',
  reschedule: 'Re-Agendar',
  schedule: 'Agendar',
  confirm: 'Confirmar',
  filter: 'Filtrar',
  filters: 'Filtros',
  clean: 'Limpar',
  restore: 'Restaurar',
  report: 'Reportar',
  success: 'O seu pedido foi efectuado com sucesso.',
  hasAvailableUpdate: 'Uma nova atualização vai ser instalada dentro de {time}s',
  update: 'ATUALIZAR'
}



// WEBPACK FOOTER //
// ./src/translations/pt/common.js